/* Search discovery. Native GET forms remain the source of commerce search analytics.
   Suggestions use Liquid so customer price gates and availability stay server-side.
   No analytics calls, persistent query storage, or automatic query replacement. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var corrections = [
    [/^beauty by bees(?=\s|$)/i, 'beauty from bees'],
    [/^good protien(?=\s|$)/i, 'good protein'],
    [/\botegano\b/gi, 'oregano'], [/\btooth paste\b/gi, 'toothpaste'],
    [/\btumeric\b/gi, 'turmeric'], [/\bjuice podwer\b/gi, 'juice powder'],
    [/\bhigh potensy fish oil\b/gi, 'high potency fish oil']
  ];
  function normalize(q) { return q.trim().replace(/\s+/g, ' '); }
  function corrected(q) {
    return corrections.reduce(function (value, pair) { return value.replace(pair[0], pair[1]); }, normalize(q));
  }
  function searchURL(q) { return root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
  var brandData = document.querySelector('[data-brand-search-index]'), brandNames = ['Beauty From Bees', 'Good Protein'];
  var collectionsURL = root + 'collections';
  try {
    var parsedBrands = brandData && JSON.parse(brandData.getAttribute('data-vendors') || brandData.textContent);
    if (Array.isArray(parsedBrands)) brandNames = parsedBrands.filter(function (name) { return typeof name === 'string' && name.trim(); });
    if (brandData && brandData.dataset.collectionsUrl) collectionsURL = brandData.dataset.collectionsUrl;
  } catch (e) { /* Preserve the existing verified shortcuts if the index is unavailable. */ }
  function brandWords(value) { return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim().replace(/\s+/g, ' '); }
  var brandIndex = brandNames.map(function (name) { var words = brandWords(name); var key = words.replace(/ /g, ''), keys = [key];
    if (name === 'Beauty From Bees') keys.push('beautybybees');
    if (name === 'Good Protein') keys.push('goodprotien');
    return {name:name, words:words.split(' '), key:key, keys:keys}; }).filter(function (brand) { return brand.key; });
  function matchingBrands(query) {
    var normalized = brandWords(corrected(query)), queryWords = normalized ? normalized.split(' ') : [], compact = normalized.replace(/ /g, '');
    if (!compact) return [];
    var ranked = brandIndex.map(function (brand) {
      var score = 0;
      brand.keys.forEach(function (key) {
        var candidateScore = compact === key ? 100 : 0;
        if (!candidateScore && key.length >= 3) {
          for (var start = 0; start < queryWords.length; start++) {
            var joined = '';
            for (var end = start; end < queryWords.length; end++) {
              joined += queryWords[end];
              if (joined === key) candidateScore = 90;
              if (joined.length >= key.length) break;
            }
          }
        }
        if (!candidateScore && compact.length >= 3 && key.indexOf(compact) === 0) candidateScore = 70;
        score = Math.max(score, candidateScore);
      });
      if (!score && queryWords.length === 1 && compact.length >= 3 && brand.words.some(function (word) { return word.indexOf(compact) === 0; })) score = 50;
      return {brand:brand,score:score};
    }).filter(function (match) { return match.score; }).sort(function (a,b) { return b.score - a.score || a.brand.name.localeCompare(b.brand.name); });
    var exact = ranked.filter(function (match) { return match.score === 100; });
    return (exact.length ? exact : ranked).slice(0,3).map(function (match) { return match.brand.name; });
  }
  function brandShortcuts(query) {
    var names = matchingBrands(query), box = document.createElement('div');
    box.className = 'lum-brand-shortcuts';
    if (names.length) box.setAttribute('aria-label', names.length === 1 ? 'Matching brand' : 'Matching brands');
    names.forEach(function (name) {
      var card = document.createElement('a'); card.className = 'lum-brand-shortcut'; card.setAttribute('data-search-brand-card', '');
      card.href = collectionsURL + '/vendors?q=' + encodeURIComponent(name); card.setAttribute('aria-label', 'Shop ' + name + ' brand');
      var label = document.createElement('span'); label.className = 'lum-brand-shortcut__label'; label.textContent = 'Brand';
      var title = document.createElement('strong'); title.textContent = 'Shop ' + name;
      var more = document.createElement('span'); more.className = 'lum-brand-shortcut__more'; more.textContent = 'View brand →';
      card.append(label,title,more); box.appendChild(card);
    });
    return box;
  }

  function link(label, url, className) {
    var a = document.createElement('a'); a.textContent = label; a.href = url;
    a.className = className || 'predictive__item'; return a;
  }
  function guidance(q, className) {
    var box = document.createElement('div'); box.className = 'lum-search-guidance';
    var fixed = corrected(q), lower = fixed.toLowerCase();
    var shortcuts = brandShortcuts(q); if (shortcuts.children.length) box.appendChild(shortcuts);
    if (fixed.toLowerCase() !== normalize(q).toLowerCase()) {
      box.appendChild(link('Did you mean “' + fixed + '”?', searchURL(fixed), className));
    }
    var categories = {iron:'iron',collagen:'collagen','protein powders':'protein-powders',toothpaste:'oral-care','oral care':'oral-care'};
    if (categories[lower]) box.appendChild(link('Browse ' + (lower === 'toothpaste' ? 'oral care' : lower), root + 'collections/' + categories[lower], className));
    return box;
  }
  document.querySelectorAll('[data-search-discovery]').forEach(function (el) {
    var q = el.getAttribute('data-search-discovery');
    var discovery = guidance(q, 'lum-chip');
    el.appendChild(discovery);
    if (discovery.querySelector('[data-search-brand-card]')) document.querySelectorAll('.lum-brandhit').forEach(function (old) { old.hidden = true; });
  });
  document.querySelectorAll('[data-predictive-wrap]').forEach(function (wrap, index) {
    var input = wrap.querySelector('[data-predictive-input]');
    var panel = wrap.querySelector('[data-predictive-panel]');
    if (!input || !panel) return;
    var timer, controller, generation = 0, choices = [], mobileOpen = false, placeholder, previousOverflow, restoringFocus = false;
    var media = window.matchMedia('(max-width:1023px)');
    var close = document.createElement('button');
    close.type = 'button'; close.className = 'lum-search-close'; close.textContent = 'Close';
    close.setAttribute('aria-label', 'Close search'); wrap.appendChild(close);
    panel.id = 'lum-search-suggestions-' + index;
    panel.setAttribute('role', 'region'); panel.setAttribute('aria-label', 'Search suggestions');
    input.setAttribute('aria-controls', panel.id); input.setAttribute('aria-expanded', 'false');
    var status = document.createElement('span'); status.className = 'lum-search-status';
    status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); wrap.appendChild(status);
    function cancel() { generation++; clearTimeout(timer); if (controller) controller.abort(); }
    function hide() {
      cancel(); panel.hidden = true; panel.replaceChildren(); choices = [];
      input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-busy'); panel.removeAttribute('aria-busy'); status.textContent = '';
    }
    function openMobile() {
      if (!wrap.hasAttribute('data-mobile-search') || !media.matches || mobileOpen) return;
      mobileOpen = true; placeholder = document.createComment('Search position');
      wrap.before(placeholder); document.body.appendChild(wrap);
      previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      wrap.classList.add('is-search-open'); wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-label', 'Search Luminate');
      try { window.history.pushState(Object.assign({}, window.history.state, {lumSearch: index}), ''); } catch (e) {}
      input.focus({preventScroll: true});
      if (normalize(input.value).length < 2) show('', '', false);
    }
    function closeMobile(fromHistory, restoreFocus) {
      if (!mobileOpen) { hide(); return; }
      mobileOpen = false; hide(); wrap.classList.remove('is-search-open');
      wrap.removeAttribute('role'); wrap.removeAttribute('aria-modal'); wrap.removeAttribute('aria-label');
      if (placeholder && placeholder.parentNode) placeholder.replaceWith(wrap);
      document.body.style.overflow = previousOverflow || '';
      if (!fromHistory && window.history.state && window.history.state.lumSearch === index) window.history.back();
      if (restoreFocus !== false) { restoringFocus = true; input.focus({preventScroll: true}); restoringFocus = false; }
    }
    function show(html, q, failed) {
      var focusedLink = document.activeElement && document.activeElement.closest('a');
      var focusedHref = focusedLink && panel.contains(focusedLink) ? focusedLink.href : null;
      panel.innerHTML = html;
      if (q) {
        var discovery = guidance(q), resultCount = panel.querySelectorAll('.predictive__item').length + discovery.querySelectorAll('[data-search-brand-card]').length;
        panel.prepend(discovery);
        document.dispatchEvent(new CustomEvent('luminate:feature-search', {detail:{surface:wrap, sequence:generation, action:failed ? 'error' : (resultCount ? 'results' : 'no_results'), count:resultCount}}));
      }
      if (failed) { var p = document.createElement('p'); p.className = 'predictive__none'; p.textContent = 'Suggestions are taking a moment. Search to see full results.'; panel.appendChild(p); }
      if (q) panel.appendChild(link('See all results for “' + q + '”', searchURL(q), 'predictive__all'));
      else { var p = document.createElement('p'); p.className = 'predictive__none'; p.textContent = 'Find your favourites. Search by product, brand, category or ingredient.'; panel.appendChild(p); }
      choices = Array.from(panel.querySelectorAll('a'));
      panel.hidden = false; input.setAttribute('aria-expanded','true'); input.removeAttribute('aria-busy'); panel.removeAttribute('aria-busy');
      status.textContent = q ? choices.length + ' suggestions. Use the down arrow to explore, or Tab to reach Add buttons.' : '';
      if (focusedHref) { var replacement = choices.find(function (choice) { return choice.href === focusedHref; }); (replacement || input).focus({preventScroll:true}); }
    }
    function request() {
      cancel(); var q = normalize(input.value), ticket = generation;
      if (q.length < 2) { show('', '', false); return; }
      // Keep the surface open without leaving stale product Add controls active.
      panel.replaceChildren(guidance(q));
      var loading = document.createElement('p'); loading.className = 'predictive__loading'; loading.textContent = 'Searching products…'; loading.setAttribute('aria-hidden','true'); panel.appendChild(loading);
      choices = Array.from(panel.querySelectorAll('a')); panel.hidden = false; input.setAttribute('aria-expanded','true');
      input.setAttribute('aria-busy','true'); panel.setAttribute('aria-busy','true'); status.textContent = 'Searching…';
      timer = setTimeout(function () {
        controller = new AbortController();
        fetch(root + 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=lum-predictive-search&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last', {signal: controller.signal})
          .then(function (res) { if (!res.ok) throw new Error('Suggestions unavailable'); return res.text(); })
          .then(function (html) {
            if (ticket !== generation) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var results = doc.querySelector('[data-lum-predictive-results]');
            if (!results) throw new Error('Missing suggestions section');
            show(results.innerHTML, q, false);
          }).catch(function (error) { if (ticket === generation && error.name !== 'AbortError') show('', q, true); });
      }, 200);
    }
    function activateSearch() {
      document.dispatchEvent(new CustomEvent('luminate:search-open', {detail:{surface:wrap}}));
      openMobile();
    }
    input.addEventListener('input', function () { activateSearch(); request(); });
    input.addEventListener('click', activateSearch);
    input.addEventListener('focus', function () {
      if (restoringFocus) return;
      activateSearch();
      if (panel.hidden && normalize(input.value).length >= 2) request();
    });
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (mobileOpen) closeMobile(false); else { hide(); restoringFocus = true; input.focus(); restoringFocus = false; } return; }
      if (mobileOpen && e.key === 'Tab') {
        var focusable = Array.from(wrap.querySelectorAll('input:not([type="hidden"]),button:not(:disabled),select:not(:disabled),a[href]')).filter(function (el) { return !el.closest('[hidden]') && el.getClientRects().length; });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      if (panel.hidden || !choices.length || e.target.matches('select,button')) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var at = choices.indexOf(document.activeElement);
        if (e.target !== input && at < 0) return;
        e.preventDefault();
        var next = at < 0 ? (e.key === 'ArrowDown' ? 0 : choices.length - 1) : at + (e.key === 'ArrowDown' ? 1 : -1);
        if (next < 0) input.focus();
        else choices[next % choices.length].focus();
      }
    });
    wrap.addEventListener('change', function (e) {
      if (!e.target.matches('[data-search-variant]')) return;
      var button = e.target.form.querySelector('button[type="submit"]'); if (button) button.disabled = !e.target.value;
    });
    wrap.addEventListener('focusout', function (e) { if (!mobileOpen && !wrap.contains(e.relatedTarget)) hide(); });
    document.addEventListener('click', function (e) { if (!mobileOpen && !wrap.contains(e.target)) hide(); });
    close.addEventListener('click', function () { closeMobile(false); });
    window.addEventListener('popstate', function () { if (mobileOpen && (!window.history.state || window.history.state.lumSearch !== index)) closeMobile(true); });
    media.addEventListener('change', function () { if (!media.matches && mobileOpen) closeMobile(false, false); });
    function closeForCart() { if (mobileOpen) closeMobile(false, false); else hide(); }
    document.addEventListener('luminate:cart-open', closeForCart);
    document.addEventListener('luminate:cart-preview-open', closeForCart);
    document.addEventListener('luminate:cart-add-success', closeForCart);
    document.addEventListener('focusin', function (e) { if (mobileOpen && !wrap.contains(e.target)) input.focus({preventScroll:true}); });
    var form = input.closest('form'); if (form) form.addEventListener('submit', function () {
      if (mobileOpen) {
        closeMobile(true, false);
        if (window.history.state && window.history.state.lumSearch === index) { var state = Object.assign({}, window.history.state); delete state.lumSearch; window.history.replaceState(state, ''); }
      } else hide();
    });
  });
})();
